import { render, staticRenderFns } from "./Admin_Header.vue?vue&type=template&id=66becb9b&scoped=true"
import script from "./Admin_Header.vue?vue&type=script&lang=js"
export * from "./Admin_Header.vue?vue&type=script&lang=js"
import style0 from "./Admin_Header.vue?vue&type=style&index=0&id=66becb9b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66becb9b",
  null
  
)

export default component.exports